module.exports = __webpack_public_path__ + "static/img/0547_3.2616d7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_3.jpg
// module id = +WYQ
// module chunks = 1